import { builderPipelineCreatorActions } from 'actions/modules/datascience';
import { HierarchySorter as SharedHierarchySorter } from 'ng-common-features/dataScience';

import { Point } from '@projectstorm/geometry';

export default (() => {
  const NODE_WIDTH = 240;
  const COLUMN_GAP = 80;
  const GRID_STEP = 80;
  const DESIRED_Y_NEAR_TIE_THRESHOLD = 8;

  const roundTo = (value, step = 10) => {
    if (step === 0) {
      return value;
    }

    return Math.round(value / step) * step;
  }

  const repaintPathfinding = ({ factory, engine }) => {
    factory.calculateCanvasMatrix();
    factory.calculateRoutingMatrix();
    factory.calculateMatrixDimensions?.();
    engine.repaintCanvas();
  }

  const updateLinks = ({ diagram, builderTasks }) => {
    const engine = diagram.getDiagramEngine();
    const factory = engine.getLinkFactories().getFactory("pathfinding");
    factory?.setLowCpuMode?.(Object.keys(builderTasks).length > 20);
    requestAnimationFrame(repaintPathfinding.bind(null, { factory, engine }));
  }

  const getNodesByIdMap = ({ diagram }) => {
    const model = diagram.getActiveModel();
    const nodeById = {};
    (model.getNodes() || []).forEach(node => {
      nodeById[node.options.id] = node;
    });
    return nodeById
  }

  const buildVisiblePortCountById = ({ taskIds, nodeById }) => {
    const visiblePortCountById = {};
    taskIds.forEach(id => {
      const ports = nodeById[id]?.getPorts?.() || {};
      visiblePortCountById[id] = Object.keys(ports).length;
    });
    return visiblePortCountById;
  }

  const applyUpdates = ({ updates, dispatch, builderTasks, diagram, nodeById }) => {
    requestAnimationFrame(() => {
      const positions = {};
      updates.forEach(({ id, position }) => {
        const node = nodeById[id];
        const alignedPosition = new Point(position.x, position.y);
        node.__silent = true;
        node.setPosition(alignedPosition);
        positions[node.options.id] = { x: alignedPosition.x, y: alignedPosition.y };
        node.__silent = false;
      });
      dispatch(builderPipelineCreatorActions.changePositions(positions));
      requestAnimationFrame(() => {
        updateLinks({ diagram, builderTasks });
      })
    });
  }

  const sort = ({ builderLinks, builderTasks, categories, diagram, MessageStore }) => dispatch => {
    try {
      if (Object.keys(builderTasks || {}).length === 0) {
        return;
      }

      const nodeById = getNodesByIdMap({ diagram });
      const taskIds = Object.keys(builderTasks || {});
      const positionById = Object.fromEntries(taskIds.map(id => [id, nodeById[id]?.position]));
      const visiblePortCountById = buildVisiblePortCountById({ taskIds, nodeById });
      const result = SharedHierarchySorter.sort({
        builderLinks,
        builderTasks,
        categories,
        positionById,
        visiblePortCountById,
        layoutOptions: {
          nodeWidth: NODE_WIDTH,
          columnGap: COLUMN_GAP,
          gridStep: GRID_STEP,
          desiredYNearTieThreshold: DESIRED_Y_NEAR_TIE_THRESHOLD
        }
      });
      if (!result) {
        MessageStore?.error?.("Could not sort diagram. Cycle detected in task dependencies.");
        return;
      }

      applyUpdates({ updates: result.updates, dispatch, builderTasks, diagram, nodeById });
    } catch (error) {
      MessageStore?.error?.(error?.message || "Could not sort diagram.");
    }
  };

  return {
    sort,
    roundTo
  };
})();
